import * as React from 'react';

/**
 * Custom hook that debounces a value, delaying updates until after the specified delay.
 * Useful for search inputs to reduce API calls or expensive operations.
 *
 * @param value The value to debounce
 * @param delay Delay in milliseconds
 * @returns The debounced value
 */
export const useDebounce = <T>(value: T, delay: number): T => {
  const [debouncedValue, setDebouncedValue] = React.useState<T>(value);

  React.useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};
